import { render, staticRenderFns } from "./AwardFilterDefaultLayout.vue?vue&type=template&id=154ee6cd&scoped=true&"
import script from "./AwardFilterDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./AwardFilterDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154ee6cd",
  null
  
)

export default component.exports